function stripTrailingSlash(value: string): string {
  return value.replace(/\/+$/, "");
}

export function thatradiothingApiBase(): string {
  const configured = process.env.NEXT_PUBLIC_THATRADIOTHING_API_BASE?.trim();
  return stripTrailingSlash(configured || "https://thatradiothing.duudey.com");
}

export function thatradiothingApiUrl(path: string): string {
  const normalizedPath = path.startsWith("/") ? path.slice(1) : path;
  return `${thatradiothingApiBase()}/${normalizedPath}`;
}

export function thatradiothingWebsocketBase(): string {
  const configured = process.env.NEXT_PUBLIC_THATRADIOTHING_WS_BASE?.trim();
  if (configured) {
    return stripTrailingSlash(configured);
  }

  return thatradiothingApiBase().replace(/^http:/i, "ws:").replace(/^https:/i, "wss:");
}
